module.exports = __webpack_public_path__ + "static/media/easy-open.8c73026d.png";